import { Division } from '@/types/cohort'
import axios from 'axios'

let abortController = new AbortController()
let signal = abortController.signal

// In production, use relative URLs (empty string) since backend serves frontend from same origin
// In development, REACT_APP_API_URL should be set to http://localhost:3001 in .env
const API_URL = process.env.REACT_APP_API_URL || ''

export const fetchMetrics = async () => {
  try {
    const res = await axios.get(API_URL + '/api/metrics')
    return res.data
  } catch (error) {
    console.log('#### Request Error:', (error as Error).message)
  }
}

export const fetchRegions = async () => {
  try {
    const res = await axios.get(API_URL + '/api/cohorts')
    return res.data
  } catch (error) {
    console.log('#### Request Error:', (error as Error).message)
  }
}

export const fetchChartData = async (location: Division) => {
  abortController.abort()
  abortController = new AbortController()
  signal = abortController.signal

  try {
    const res = await axios.get(
      `${API_URL}/api/data?cohort=${location.name}&cohort_type=${location.type}`,
      { signal: signal }
    )
    return res
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log('#### Request Aborted by new request!', error.message)
    } else {
      console.log('#### Request Error:', (error as Error).message)
    }
  }
}
